import { RouterProvider } from "react-router-dom";
import { routers } from "./Routers";
import "./App.css";
import { Provider } from "react-redux";
import { store } from "./Redux/store";

function App() {
  return (
    <Provider store={store}>
      <RouterProvider router={routers} />
    </Provider>
  );
}

export default App;
